
import React from 'react';
import Layout from '@/components/layout/Layout';
import ArtistFunding from '@/components/funding/ArtistFunding';

const Funding: React.FC = () => {
  return (
    <Layout>
      <div className="container max-w-7xl mx-auto py-8 px-4">
        <div className="mb-6">
          <h1 className="text-3xl font-bold">Artist Funding</h1>
          <p className="text-muted-foreground">Find and manage funding opportunities for your music career</p>
        </div>
        
        <ArtistFunding />
      </div>
    </Layout>
  );
};

export default Funding;
